import React, { useEffect, useState } from "react";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Badge } from "primereact/badge";
import { Dialog } from "primereact/dialog";
import { TabPanel, TabView } from "primereact/tabview";
import { Toolbar } from "primereact/toolbar";
import { InputText } from "primereact/inputtext";
import { devicesManagementService } from "../services/DevicesManagementService";
import { formatDateTime } from "../config/Config";

export const KitConfiguration = () => {
	var [loading, setLoading] = useState(true);
	var [tableData, setTableData] = useState([]);
	var [deviceSyncData, setDeviceSyncData] = useState([]);
	var [showDialog, setShowDialog] = useState(false);
	var [selectedDevice, setSelectedDevice] = useState({});
	const [totalRecords, setTotalRecords] = useState([]);
	const [searchValue, setSearchValue] = useState("");
	const [refreshSyncInformation, setRefreshSyncInformation] = useState(false);

	const [lazyState, setlazyState] = useState({
		first: 0,
		rows: 10,
		page: 0,
		search: ""
	});

	const onPageChange = (event) => {
		setlazyState(event);
	};

	const onSearch = (event) => {
		setlazyState((prev) => ({
			...prev,
			first: 0, // Reset to the first page on new search
			search: searchValue
		}));
	};

	function DeviceView() {
		var data = [];
		data.push({
			col1: "Name:",
			col2: selectedDevice?.name,
			col3: "Manufacturer",
			col4: selectedDevice?.manufacturer
		});

		data.push({
			col1: "Active:",
			col2: selectedDevice?.active ? <Badge value="Yes" severity="success"></Badge> : <Badge value="No" severity="error"></Badge>,
			col3: "Serial No",
			col4: selectedDevice?.serialNo
		});
		data.push({
			col1: "Model:",
			col2: selectedDevice?.model
		});
		data.push({
			col1: "DeviceID:",
			col2: selectedDevice?.deviceID,
			col3: "Description",
			col4: selectedDevice?.description
		});
		return (
			<div>
				<DataTable
					className="remove-border"
					size="small"
					scrollable={true}
					value={data}
					dataKey="id"
					responsiveLayout="scroll"
					style={{ width: "100%" }}
					emptyMessage="No documents"
				>
					<Column style={{ width: "250px" }} field="col1" body={(e) => <b>{e.col1}</b>}></Column>
					<Column style={{ width: "250px" }} field="col2"></Column>
					<Column style={{ width: "250px" }} field="col3" body={(e) => <b>{e.col3}</b>}></Column>
					<Column style={{ width: "250px" }} field="col4" />
				</DataTable>
				<br />
			</div>
		);
	}

	const onRefreshSyncInformation = (event) => {
		setLoading(true);
		devicesManagementService.getLatestSyncinformationByID(selectedDevice?.componentID).then((res) => {
			setDeviceSyncData(res);
			setLoading(false);
		});
	};

	useEffect(() => {
		// setDeviceSyncData([])
		if (selectedDevice?.componentID) {
			setLoading(true);
			devicesManagementService.getLatestSyncinformationByID(selectedDevice?.componentID).then((res) => {
				setDeviceSyncData(res);
				setLoading(false);
			});
		}
	}, [selectedDevice]);

	useEffect(() => {
		var params = {
			pageIndex: 1,
			pageSize: lazyState.rows * (lazyState.page + 1),
			search: lazyState.search
		};

		setLoading(true);
		devicesManagementService.getDevices(params).then((res) => {
			setTableData(res.components);
			setTotalRecords(res.count);
			setLoading(false);
		});
	}, [lazyState]);

	return (
		<div className="grid">
			<div className="col-12">
				<div className="card">
					<h5>Device Management</h5>
					<div className="">
						<Toolbar
							className="mb-4"
							left={
								<h4 className="p-0 m-0">Registered Devices: {totalRecords}</h4>
							}
							right={
								<div>
									<span className="block md:mt-0 p-input-icon-left">
										<i className="pi pi-search" />
										<InputText
											type="search"
											placeholder="Search"
											value={searchValue}
											onChange={(e) => setSearchValue(e.target.value)}
											style={{ width: "280px" }}
										/>
										<Button className="p-button-success ml-4" label="Search" onClick={onSearch} />
									</span>
								</div>
							}
						></Toolbar>
					</div>
					<Dialog
						header={<h5>{selectedDevice?.name}</h5>}
						style={{ maxWidth: 900, width: "95%" }}
						visible={showDialog}
						onHide={() => setShowDialog(false)}
					>
						<TabView>
							<TabPanel header="Details">
								<DeviceView />
							</TabPanel>
							<TabPanel header="Sync Information">
								<Button
									icon="pi pi-refresh"
									type="small"
									className="mb-4 mr-2"
									tooltip="Refresh"
									tooltipOptions={{ position: "top" }}
									onClick={onRefreshSyncInformation}
								/>
								<DataTable size="small" value={deviceSyncData} dataKey="syncInformationID" loading={loading}>
									<Column field="syncTypeName" header="Sync Type" />
									<Column field="syncTimestamp" header="Last Sync Time" body={(rowData) => formatDateTime(rowData.syncTimestamp)} />
									<Column field="noOfRecords" header="No. Of Records" />
									<Column
										field="isSuccesful"
										header="Succesful"
										body={(rowData) => {
											return rowData.isSuccesful == 1 ? "Yes" : "No";
										}}
									/>
									<Column field="errors" header="Errors" />
								</DataTable>
							</TabPanel>
						</TabView>
					</Dialog>
					<DataTable
						first={lazyState.first}
						size="small"
						value={tableData}
						loading={loading}
						scrollable={true}
						emptyMessage="No data found."
						resizableColumns
						columnResizeMode="expand"
						rows={lazyState.rows}
						rowsPerPageOptions={[10, 20, 50]}
						totalRecords={totalRecords}
						onPage={onPageChange}
						paginator={true}
					>
						<Column field="name" header="Name" style={{ width: "250px" }}></Column>
						<Column field="serialNo" header="Serial No"></Column>
						<Column field="deviceID" header="Device ID"></Column>
						<Column field="dateCreated" header="Created Date" body={(rowData) => formatDateTime(rowData.dateCreated)}></Column>
						<Column field="dateUpdated" header="Updated Date" body={(rowData) => formatDateTime(rowData.dateUpdated)}></Column>
						<Column
							field="active"
							header="Active"
							body={(row) =>
								row.active ? <Badge value="Yes" severity="success"></Badge> : <Badge value="No" severity="error"></Badge>
							}
						></Column>
						<Column
							field="Action"
							header="Action"
							body={(row) => (
								<Button
									style={{ textAlign: "center", width: "30px", height: "30px" }}
									icon={"pi pi-eye"}
									className="p-button-primary p-button-rounded mr-2 "
									tooltip="Click to View"
									onClick={() => {
										setShowDialog(true);
										setSelectedDevice(row);
									}}
								/>
							)}
						></Column>
					</DataTable>
				</div>
			</div>
		</div>
	);
};
